module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.04b9bfc3.woff";